var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9799 2.00117C11.0898 2.54242 10.74 3.07023 10.1988 3.18005C6.6744 3.89518 3.89506 6.67453 3.17993 10.1989C3.07011 10.7401 2.5423 11.0899 2.00105 10.9801C1.45979 10.8702 1.11005 10.3424 1.21987 9.80117C2.09475 5.48952 5.4894 2.09487 9.80105 1.22C10.3423 1.11017 10.8701 1.45991 10.9799 2.00117Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00081 13.02C2.54203 12.91 3.06992 13.2596 3.17988 13.8009C3.89598 17.3256 6.67458 20.1048 10.1988 20.8199C10.74 20.9297 11.0898 21.4576 10.9799 21.9988C10.8701 22.5401 10.3423 22.8898 9.80105 22.78C5.48923 21.9051 2.09582 18.5103 1.21992 14.199C1.10996 13.6578 1.45958 13.1299 2.00081 13.02Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9991 13.0199C22.5403 13.1297 22.89 13.6576 22.7802 14.1988C21.9053 18.5106 18.5106 21.904 14.1993 22.7799C13.6581 22.8899 13.1302 22.5403 13.0202 21.999C12.9103 21.4578 13.2599 20.9299 13.8011 20.82C17.3258 20.1039 20.1051 17.3253 20.8202 13.8011C20.93 13.2598 21.4578 12.9101 21.9991 13.0199Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0202 2.00117C13.13 1.45991 13.6578 1.11017 14.1991 1.22C18.5109 2.09491 21.9043 5.48965 22.7802 9.80093C22.8901 10.3422 22.5405 10.87 21.9993 10.98C21.4581 11.09 20.9302 10.7403 20.8202 10.1991C20.1041 6.6744 17.3255 3.89514 13.8013 3.18005C13.2601 3.07023 12.9103 2.54242 13.0202 2.00117Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C9 0.447715 9.44772 0 10 0H14C14.5523 0 15 0.447715 15 1V7.416C15 7.96828 14.5523 8.416 14 8.416C13.4477 8.416 13 7.96828 13 7.416V2H11V7.416C11 7.96828 10.5523 8.416 10 8.416C9.44772 8.416 9 7.96828 9 7.416V1Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.584 10C15.584 9.44772 16.0317 9 16.584 9H23C23.5523 9 24 9.44772 24 10V14C24 14.5523 23.5523 15 23 15H16.584C16.0317 15 15.584 14.5523 15.584 14C15.584 13.4477 16.0317 13 16.584 13H22V11H16.584C16.0317 11 15.584 10.5523 15.584 10Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.584C10.5523 15.584 11 16.0317 11 16.584V22H13V16.584C13 16.0317 13.4477 15.584 14 15.584C14.5523 15.584 15 16.0317 15 16.584V23C15 23.5523 14.5523 24 14 24H10C9.44772 24 9 23.5523 9 23V16.584C9 16.0317 9.44772 15.584 10 15.584Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 9.44772 0.447715 9 1 9H7.416C7.96828 9 8.416 9.44772 8.416 10C8.416 10.5523 7.96828 11 7.416 11H2V13H7.416C7.96828 13 8.416 13.4477 8.416 14C8.416 14.5523 7.96828 15 7.416 15H1C0.447715 15 0 14.5523 0 14V10Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.0a4f3fb13645272f41d388da0c0bb767.svg";
export { ForwardRef as ReactComponent };